import { USStates } from "@Core/Enums/USStates";
import SelectInput from "@Core/Components/Inputs/SelectInput";
import { SelectHTMLAttributes } from "react";

type USStateSelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
    isFocused?: boolean;
    useAbbreviations?: boolean;
};

const USStateSelect = ({
    className = "",
    isFocused = false,
    useAbbreviations = false,
    ...props
}: USStateSelectProps) => {
    const states = Object.keys(USStates) as (keyof typeof USStates)[];
    return (
        <SelectInput className={className} isFocused={isFocused} {...props}>
            {states.map((state) => (
                <option key={state} value={state}>
                    {useAbbreviations ? state : USStates[state]}
                </option>
            ))}
        </SelectInput>
    );
};

export default USStateSelect;
